export class NICESkillAgent {

    agentId: number;
    firstName: string;
    middleName: string;
    lastName: string;
    agentProficiencyValue: number;
    // agentProficiencyName: string;
    // campaignId: number;
    // campaignName: string;
    // emailFromAddress: string;
    // internalId: string;
    isActive: boolean;
    isSkillActive: boolean;
    isAssigned: boolean;
    // isDialer: boolean;
    // isNaturalCalling: boolean;
    // isNaturalCallingRunning: boolean;
    isOutbound: boolean;
    mediaTypeId: number;
    mediaTypeName: string;
    mediaTypeIcon: string;
    customMediaTypeName: string;
    name: string;

    // notes: string;
    outboundStrategy: string;
    // priorityBlending: boolean;
    // requireDisposition: boolean;
    // scriptDisposition: boolean;
    // skillId: number;
    // skillName: string;
    // teamId: number;
    // teamName: string;
    // useACW: boolean;
    // useDisposition: boolean;
    // useSecondaryDispositions: boolean;
    // screenPopTriggerEvent: string;
    teamName: string;

    constructor(jsonData?) {
        if (jsonData) {
            if(jsonData.firstName)
            {
                this.firstName = jsonData.firstName;
                this.middleName = jsonData.middleName;
                this.lastName = jsonData.lastName;
                this.teamName = jsonData.teamName;
                this.name = (jsonData.firstName + ' ' + jsonData.middleName + ' ' + jsonData.lastName).replace('  ', ' ');
            }
            else {
                this.name = (jsonData.agentName);
                this.teamName = '';
            }
            this.agentId = jsonData.agentId;
            this.agentProficiencyValue = jsonData.agentProficiencyValue;
            this.isActive = jsonData.isActive;
            this.isSkillActive = jsonData.isSkillActive;
            this.isAssigned = jsonData.isAssigned;
            this.isOutbound = jsonData.isOutbound;
            this.mediaTypeId = jsonData.mediaTypeId;
            this.mediaTypeName = jsonData.mediaTypeName;
            this.outboundStrategy = jsonData.outboundStrategy;
            this.mediaTypeIcon = this.getSkillIcon();
            this.customMediaTypeName = this.configCustomMediaTypeName();
        }else{
            this.agentProficiencyValue = 3;
            this.isActive = true;
            this.isOutbound = false;
            this.mediaTypeId = null;
            this.mediaTypeName = '';
            this.agentId = null;
            this.lastName = '';

        }
    }

    configCustomMediaTypeName(): string {
        switch (this.mediaTypeId) {
            // Email
            case 1:
                if (this.isOutbound)
                {
                    return 'Email Outbound';
                }
                return 'Email Outbound';
            // FAX
            case 2:
                return 'FAX';
            // Chat
            case 3:
                return 'Chat';
            // Phone
            case 4:
                if (this.isOutbound)
                {
                    if (this.outboundStrategy === 'Personal Connection') {
                        // if (this.agentless) {
                        //     return 'Phone Dialer Blaster';
                        // }
                        return 'Phone Dialer';
                    }
                    return 'Phone Outbound';
                }
                return 'Phone Inbound';
            // Voicemail
            case 5:
                return 'Voicemail';
            // Work Item
            case 6:
                return 'Work Item';
            // SMS
            case 7:
                return 'SMS';
            // Social
            case 8:
                return 'Social';
            // Digital
            case 9:
                return 'Digital';
        }
    }
    getSkillIcon(): string {
        switch (this.mediaTypeId) {
            // Email
            case 1:
                return 'email';
            // FAX
            case 2:
                return 'email';
            // Chat
            case 3:
                return 'chat';
            // Phone
            case 4:
                if (this.isOutbound)
                {
                    if (this.outboundStrategy === 'Personal Connection') {
                        return 'flash_on';
                    }
                    return 'phone_forwarded';

                }
                return 'phone_callback';
            // Voicemail
            case 5:
                return 'voicemail';
            // Work Item
            case 6:
                return 'confirmation_number';
            // SMS
            case 7:
                return 'chat';
            // Social
            case 8:
                return 'social';
            // Digital
            case 9:
                return 'forum';
        }
    }

}
